// ChipSection.jsx
// Memoized chip section component to prevent unnecessary re-renders

import React, {memo} from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import Button from '@mui/material/Button';

const ChipSection = memo(({title, options, selected, onToggle, expanded, canToggle, toggleShowMore}) => {
    return (
        <Box sx={{mb: 2}}>
            <Typography variant="subtitle2" color="text.secondary" sx={{mb: 1}}>
                {title}
            </Typography>
            <Stack direction="row" gap={1} flexWrap="wrap">
                {options.map((option) => (
                    <Chip
                        key={option.value}
                        label={option.label}
                        color={selected.includes(option.value) ? 'primary' : 'default'}
                        variant={selected.includes(option.value) ? 'filled' : 'outlined'}
                        onClick={() => onToggle(option.value)}
                    />
                ))}
            </Stack>
            {canToggle && (
                <Button size="small" onClick={toggleShowMore} sx={{mt: 1}}>
                    {expanded ? 'Show Less' : 'Show More'}
                </Button>
            )}
        </Box>
    );
});

ChipSection.displayName = 'ChipSection';

ChipSection.propTypes = {
    title: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
    })).isRequired,
    selected: PropTypes.arrayOf(PropTypes.string).isRequired,
    onToggle: PropTypes.func.isRequired,
    expanded: PropTypes.bool.isRequired,
    canToggle: PropTypes.bool.isRequired,
    toggleShowMore: PropTypes.func.isRequired,
};

export default ChipSection;
